export function isUserLoggedIn() {
  try {
    const token = localStorage.getItem("femtyz_token");
    return Boolean(token) && token !== "null" && token !== "undefined";
  } catch {
    return false;
  }
}

export function openAuthPopup(mode = "login") {
  window.dispatchEvent(new CustomEvent("femtyz:open-auth", { detail: { mode } }));
}

export function requireAuth(mode = "login") {
  if (isUserLoggedIn()) return true;
  openAuthPopup(mode);
  return false;
}
